var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("供应系统")]),
            _c("el-breadcrumb-item", [_vm._v("统计管理")]),
            _c("el-breadcrumb-item", [_vm._v("统计报表")]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "hx-form-container box-shadow" },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "供应总计", name: "baseTotalStatistics" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "mg-auto mgt10",
                          staticStyle: { width: "95%" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "hx-form-container box-shadow" },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "listForm",
                                  attrs: { "label-width": "100px" },
                                },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 24 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 16 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "日期查询：" } },
                                            [
                                              _c("date-picker-group", {
                                                model: {
                                                  value: _vm.timeInterval,
                                                  callback: function ($$v) {
                                                    _vm.timeInterval = $$v
                                                  },
                                                  expression: "timeInterval",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.loadTotalTableData(
                                                        "baseTotalStatistics"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 查询 ")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "hx-table-result",
                                {
                                  attrs: {
                                    "show-pager-on-one-page": false,
                                    loading: _vm.tableLoading,
                                  },
                                },
                                [
                                  _c("div", {
                                    attrs: { slot: "action" },
                                    slot: "action",
                                  }),
                                  _c("hx-table-result-col", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "wrap-table-info-display",
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "align-left",
                                            attrs: {
                                              type: "primary",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.exportExcel(
                                                  "/statistic/supply/goodsInfo/export"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 导出 ")]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "table-info-display" },
                                          [
                                            _c("span", [_vm._v("总条数：")]),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "alert-text ft16",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.tableTotalData.length
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c(
                                    "el-table",
                                    {
                                      attrs: {
                                        slot: "content",
                                        stripe: "",
                                        data: _vm.tableTotalData,
                                        "max-height": "800",
                                        border: "",
                                      },
                                      slot: "content",
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "supplyCentre",
                                          align: "center",
                                          label: "供应单位",
                                        },
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          width: "100",
                                          prop: "guaranteeCount",
                                          align: "center",
                                          label: "保障人数",
                                        },
                                      }),
                                      _vm._l(
                                        _vm.columnTotalList,
                                        function (item, index1) {
                                          return _c(
                                            "el-table-column",
                                            {
                                              key: index1,
                                              attrs: {
                                                align: "center",
                                                label: item.title,
                                              },
                                            },
                                            _vm._l(
                                              item.secondTitle,
                                              function (item2, index2) {
                                                return _c("el-table-column", {
                                                  key: index2,
                                                  attrs: {
                                                    width: "120",
                                                    align: "center",
                                                    label: item2,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  scope.row
                                                                    .goodsList[
                                                                    index1
                                                                  ][index2]
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        }
                                      ),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "saleAmount",
                                          label: "预定总金额",
                                          fixed: "right",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " ￥" +
                                                    _vm._s(
                                                      scope.row.saleAmount
                                                        ? scope.row.saleAmount.toFixed(
                                                            2
                                                          )
                                                        : 0
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          align: "center",
                                          prop: "saleAmount",
                                          label: "销售总金额",
                                          fixed: "right",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " ￥" +
                                                    _vm._s(
                                                      scope.row.amountTotal
                                                        ? scope.row.amountTotal.toFixed(
                                                            2
                                                          )
                                                        : 0
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: "供应点总计",
                  name: "supplyCentreDetailStatistics",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "mg-auto mgt10",
                          staticStyle: { width: "95%" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "hx-form-container box-shadow" },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "listForm",
                                  attrs: { "label-width": "100px" },
                                },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 24 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "供应点：" } },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: { size: "small" },
                                                  model: {
                                                    value: _vm.siteId,
                                                    callback: function ($$v) {
                                                      _vm.siteId = $$v
                                                    },
                                                    expression: "siteId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.supplyCentreList,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.title,
                                                        value: item.id,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.loadTableData(
                                                        "supplyCentreDetailStatistics"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 查询 ")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "hx-table-result",
                                {
                                  attrs: {
                                    "show-pager-on-one-page": false,
                                    loading: _vm.tableLoading,
                                  },
                                },
                                [
                                  _c("div", {
                                    attrs: { slot: "action" },
                                    slot: "action",
                                  }),
                                  _c("hx-table-result-col", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "wrap-table-info-display",
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "align-left",
                                            attrs: {
                                              type: "primary",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.exportExcel(
                                                  "/statistic/site/goodsInfo/export"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 导出 ")]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "table-info-display" },
                                          [
                                            _c("span", [_vm._v("总条数：")]),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "alert-text ft16",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.tableData.length)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c(
                                    "el-table",
                                    {
                                      attrs: {
                                        slot: "content",
                                        stripe: "",
                                        "span-method": _vm.rowSpanCombine,
                                        "max-height": "800",
                                        data: _vm.tableData,
                                        border: "",
                                      },
                                      slot: "content",
                                    },
                                    _vm._l(
                                      _vm.columnList,
                                      function (item, index) {
                                        return _c("el-table-column", {
                                          key: index,
                                          attrs: {
                                            label: item,
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row[index]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "基地总计", name: "baseDetailStatistics" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "mg-auto mgt10",
                          staticStyle: { width: "95%" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "hx-form-container box-shadow" },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "listForm",
                                  attrs: { "label-width": "100px" },
                                },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 24 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 16 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "日期查询：" } },
                                            [
                                              _c("date-picker-group", {
                                                model: {
                                                  value: _vm.timeInterval,
                                                  callback: function ($$v) {
                                                    _vm.timeInterval = $$v
                                                  },
                                                  expression: "timeInterval",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.loadTableData(
                                                        "baseDetailStatistics"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 查询 ")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "hx-table-result",
                                {
                                  attrs: {
                                    "show-pager-on-one-page": false,
                                    loading: _vm.tableLoading,
                                  },
                                },
                                [
                                  _c("div", {
                                    attrs: { slot: "action" },
                                    slot: "action",
                                  }),
                                  _c("hx-table-result-col", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "wrap-table-info-display",
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "align-left",
                                            attrs: {
                                              type: "primary",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.exportExcel(
                                                  "/statistic/baseSupplySituation/export"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" 导出 ")]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "table-info-display" },
                                          [
                                            _c("span", [_vm._v("总条数：")]),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "alert-text ft16",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.tableData.length)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c(
                                    "el-table",
                                    {
                                      attrs: {
                                        slot: "content",
                                        stripe: "",
                                        "max-height": "800",
                                        "span-method": _vm.rowSpanCombine,
                                        data: _vm.tableData,
                                        border: "",
                                      },
                                      slot: "content",
                                    },
                                    _vm._l(
                                      _vm.columnList,
                                      function (item, index) {
                                        return _c("el-table-column", {
                                          key: index,
                                          attrs: {
                                            label: item,
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row[index]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }